import dnshSvg from 'assets/kosmos/DNSH.svg';
import sdgSvg from 'assets/kosmos/SDGs.svg';
import sdgLogo from 'assets/kosmos/sdg-logo.png';
import taxonomySvgOld from 'assets/kosmos/EU-Taxonomy.svg';
import taxonomySvg from 'assets/kosmos/EU-Taxonomy-New.svg';
import greenHouseGasSvg from 'assets/kosmos/Green-House-Gas.svg';
import governanceSvg from 'assets/kosmos/Governance.svg';
import dualUseGoods from 'assets/kosmos/Dual-Use-Goods.svg';
import newsCheck from 'assets/kosmos/news-check.svg';
import smartGovernanceOff from 'assets/kosmos/Smart-Governance-OFF.svg';
import smartGovernanceOn from 'assets/kosmos/Smart-Governance-ON.svg';
import illegalLogging from 'assets/kosmos/illegal-logging.svg';
import kosmosLanding from 'assets/kosmos/kosmosLanding.svg';

import sdgIcon1 from 'assets/kosmos/sdgs/E-WEB-Goal-01.png';
import sdgIcon2 from 'assets/kosmos/sdgs/E-WEB-Goal-02.png';
import sdgIcon3 from 'assets/kosmos/sdgs/E-WEB-Goal-03.png';
import sdgIcon4 from 'assets/kosmos/sdgs/E-WEB-Goal-04.png';
import sdgIcon5 from 'assets/kosmos/sdgs/E-WEB-Goal-05.png';
import sdgIcon6 from 'assets/kosmos/sdgs/E-WEB-Goal-06.png';
import sdgIcon7 from 'assets/kosmos/sdgs/E-WEB-Goal-07.png';
import sdgIcon8 from 'assets/kosmos/sdgs/E-WEB-Goal-08.png';
import sdgIcon9 from 'assets/kosmos/sdgs/E-WEB-Goal-09.png';
import sdgIcon10 from 'assets/kosmos/sdgs/E-WEB-Goal-10.png';
import sdgIcon11 from 'assets/kosmos/sdgs/E-WEB-Goal-11.png';
import sdgIcon12 from 'assets/kosmos/sdgs/E-WEB-Goal-12.png';
import sdgIcon13 from 'assets/kosmos/sdgs/E-WEB-Goal-13.png';
import sdgIcon14 from 'assets/kosmos/sdgs/E-WEB-Goal-14.png';
import sdgIcon15 from 'assets/kosmos/sdgs/E-WEB-Goal-15.png';
import sdgIcon16 from 'assets/kosmos/sdgs/E-WEB-Goal-16.png';
import sdgIcon17 from 'assets/kosmos/sdgs/E-WEB-Goal-17.png';

const generateSdgIcon = (index = 1) => {
  if (index < 1 || index > 17) {
    throw new Error('1-17 allowed');
  }
  switch (index) {
    case 1:
      return sdgIcon1;
    case 2:
      return sdgIcon2;
    case 3:
      return sdgIcon3;
    case 4:
      return sdgIcon4;
    case 5:
      return sdgIcon5;
    case 6:
      return sdgIcon6;
    case 7:
      return sdgIcon7;
    case 8:
      return sdgIcon8;
    case 9:
      return sdgIcon9;
    case 10:
      return sdgIcon10;
    case 11:
      return sdgIcon11;
    case 12:
      return sdgIcon12;
    case 13:
      return sdgIcon13;
    case 14:
      return sdgIcon14;
    case 15:
      return sdgIcon15;
    case 16:
      return sdgIcon16;
    case 17:
      return sdgIcon17;
    default:
      return undefined;
  }
};

const generateScoreSvg = (score = 0) => {
  if (score < 0 || score > 1000) {
    throw new Error('0-1000 allowed');
  }
  const index = Math.floor(score / 50);
  return require(`../assets/kosmos/scores/${index}.svg`);
};

export {
  dnshSvg,
  sdgSvg,
  taxonomySvg,
  taxonomySvgOld,
  governanceSvg,
  greenHouseGasSvg,
  dualUseGoods,
  newsCheck,
  sdgLogo,
  smartGovernanceOn,
  smartGovernanceOff,
  illegalLogging,
  generateSdgIcon,
  generateScoreSvg,
  kosmosLanding,
};
